export enum RecordToPropertyAssociationMode {
    ASSOCIATE,
    DO_NOT_ASSOCIATE
}
